import { z } from 'zod';

/** The food record's two tabs: the editor, and every change with Revert. */
export const FOOD_DETAIL_TABS = ['details', 'history'] as const;
export type FoodDetailTab = (typeof FOOD_DETAIL_TABS)[number];

/**
 * The open tab lives in the URL, as on the exercise record: "Kulfi's History"
 * is a link an operator can paste into a ticket.
 */
export const foodDetailSearchSchema = z.object({
  tab: z.enum(FOOD_DETAIL_TABS).default('details').catch('details'),
});

export type FoodDetailSearch = z.infer<typeof foodDetailSearchSchema>;
